import axios from "axios";
import store from "../redux/store"; // adjust to your actual path
import { logout } from "../redux/features/authSlice";
import { setExpiredModalOpen } from "../redux/features/expiredModalSlice";

// export const baseURL = "http://localhost:5010";
// export const baseURL = "https://diamond-server-production.vercel.app";

// new github diamond
export const baseURL = "https://diamond-server-25-new-github-hrn3.vercel.app";

export const publicClient = axios.create({
  // baseURL: "http://localhost:5010/api",
  // baseURL: "https://diamond-server-production.vercel.app/api",
  baseURL: "https://diamond-server-25-new-github-hrn3.vercel.app/api",

  headers: {
    "Content-Type": "application/json",
  },
});

export const privateClient = axios.create({
  // baseURL: "http://localhost:5010/api",
  // baseURL: "https://diamond-server-production.vercel.app/api",
  // new github diamond
  baseURL: "https://diamond-server-25-new-github-hrn3.vercel.app/api",

  headers: {
    "Content-Type": "application/json",
  },
});

// Add interceptor to attach token to privateClient
privateClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("actkn");
  if (token) {
    // Ensure headers exist
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

privateClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.log("🔴 AXIOS INTERCEPTOR TRIGGERED", error?.response?.status);

      store.dispatch(logout());

      store.dispatch(setExpiredModalOpen(true));
      localStorage.removeItem("actkn");
    }

    return Promise.reject(error);
  },
);
